import { forwardRef } from "react";
// @ts-expect-error - this will be resolved at build time
import { Box } from "@xsolla/xui-primitives";
import { useResolvedTheme } from "@xsolla/xui-core";
import type { WorkAreaProps } from "./types";

const getBorderRadius = (
  type: WorkAreaProps["type"],
  baseRadius: number
): string | number => {
  switch (type) {
    case "full-screen":
      return 0;
    case "bottom-sheet":
      return `${baseRadius}px ${baseRadius}px 0 0`;
    default:
      return baseRadius;
  }
};

export const WorkArea = forwardRef<any, WorkAreaProps>(
  (
    {
      children,
      openContent = false,
      stretched = false,
      fetching = false,
      type = "popup",
      align,
      backgroundColor,
      testID,
      themeMode,
      themeProductContext,
    },
    ref
  ) => {
    const { theme } = useResolvedTheme({ themeMode, themeProductContext });
    const sizing = theme.sizing.modal();

    return (
      <Box
        testID={testID}
        ref={ref}
        backgroundColor={backgroundColor ?? theme.colors.background.primary}
        width="100%"
        height={stretched ? "100%" : "auto"}
        flexDirection="column"
        alignItems={align === "center" ? "center" : "stretch"}
        style={{
          borderRadius: getBorderRadius(type, sizing.borderRadius),
          overflow: "hidden",
          color: theme.colors.content.primary,
        }}
      >
        <Box
          width="100%"
          height="100%"
          flexDirection="column"
          alignItems={align === "center" ? "center" : "stretch"}
          style={{ textAlign: align === "center" ? "center" : "left" }}
        >
          {fetching ? (
            <Box
              alignItems="center"
              justifyContent="center"
              width="100%"
              height="100%"
            >
              <div>Loading...</div>
            </Box>
          ) : (
            children
          )}
        </Box>
      </Box>
    );
  }
);

WorkArea.displayName = "WorkArea";
